import type { PageHeaderTabSelectProps } from "./types-tab-select";
import { useTabSelect } from "./use-tab-select";
import { PageHeaderTabSelectView } from "./view-tab-select";

export function PageHeaderTabSelect(props: PageHeaderTabSelectProps) {
  const viewModel = useTabSelect(props);

  return <PageHeaderTabSelectView {...viewModel} />;
}
PageHeaderTabSelect.displayName = "PageHeader.TabSelect";
